export default __webpack_public_path__ + "static/media/invenoryManagementAF.77c7e9f6.png";